import { RoleSchema } from './types';

export const getRoleIdByName = (
  apiRoles: RoleSchema[],
  roleName: string,
) => apiRoles.find((role) => role.role_name === roleName)?.role_id;
